import { render, staticRenderFns } from "./newCenter.vue?vue&type=template&id=5d17f67f&scoped=true"
import script from "./newCenter.vue?vue&type=script&lang=js"
export * from "./newCenter.vue?vue&type=script&lang=js"
import style0 from "./newCenter.vue?vue&type=style&index=0&id=5d17f67f&prod&scoped=true&lang=scss"
import style1 from "./newCenter.vue?vue&type=style&index=1&id=5d17f67f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d17f67f",
  null
  
)

export default component.exports